import * as ReactQuery from '@tanstack/react-query';

export function queryClientFactory(config: ReactQuery.QueryClientConfig = {}) {
  return new ReactQuery.QueryClient({
    ...config,
    defaultOptions: {
      ...config.defaultOptions,
      queries: {
        retry: 3,
        retryDelay(failureCount) {
          return failureCount * 100;
        },
        ...config.defaultOptions?.queries,
      },
    },
  });
}
